module.exports = __webpack_public_path__ + "img/設定歯車アイコン.7646ac53.svg";